const initialState = {
  isModalOpen: false,
  children: null,
};

export const openModal = (state, { payload }) => ({
  ...state,
  isModalOpen: true,
  ...payload
});

export const closeModal = () => initialState;

export default initialState;
